export default "__VITE_ASSET__CxyR0Qoz__"